/**
 * Canonical preflop domain constants. Mirrored from docs/02-domain-model.md
 * but expressed in a single language (TypeScript) — Supabase/Edge Functions
 * use the same module, so no cross-language parity story is needed.
 */

export const RANKS = ["A", "K", "Q", "J", "T", "9", "8", "7", "6", "5", "4", "3", "2"] as const;

export type Rank = (typeof RANKS)[number];

export const RANK_INDEX: Readonly<Record<Rank, number>> = Object.freeze(
  Object.fromEntries(RANKS.map((r, i) => [r, i])) as Record<Rank, number>,
);


